(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["playroots-share-bar"] && !Shopify.designMode) return;
  try {
    if (!window.__playrootsShareBound) {
    window.__playrootsShareBound = true;
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-playroots-share]');
      if (!button) return;
      event.preventDefault();
      var title = button.getAttribute('data-share-title') || document.title;
      var url = button.getAttribute('data-share-url') || window.location.href;
      var label = button.querySelector('[data-share-label]');
      var restore = function (isCopied) {
        if (label) label.textContent = button.getAttribute(isCopied ? 'data-share-copied-label' : 'data-share-label');
        button.title = button.getAttribute(isCopied ? 'data-share-copied-title' : 'data-share-label');
        button.toggleAttribute('data-share-copied', isCopied);
      };
      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
        return;
      }
      var copied = function () {
        restore(true);
        setTimeout(function () {
          restore(false);
        }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(copied).catch(function () {
          window.prompt(button.getAttribute('data-share-copy-prompt'), url);
        });
        return;
      }
      window.prompt(button.getAttribute('data-share-copy-prompt'), url);
    });
  }
  } catch(e) { console.error(e); }
})();

})();
